import * as components from './components'

export default [
  {
    path: '/regions',
    name: 'regions',
    component: components.regionsDocuments
  }
]
